export const APP_CONFIG__SET_MODAL_STATE = 'APP_CONFIG__SET_MODAL_STATE';
export const APP_CONFIG__SET_DASH_CONFIGS = 'APP_CONFIG__SET_DASH_CONFIGS';
export const APP_CONFIG__SET_LIST_CONFIGS = 'APP_CONFIG__SET_LIST_CONFIGS';
export const APP_CONFIG__SET_ANALYTICS_CONFIGS = 'APP_CONFIG__SET_ANALYTICS_CONFIGS';
export const APP_CONFIG__SET_SIDEBAR_STATE = 'APP_CONFIG__SET_SIDEBAR_STATE';
export const APP_STATE_SET_FILTER = 'APP_STATE_SET_FILTER';
export const APP_STATE_SET_CURRENT_INCIDENT = 'APP_STATE_SET_CURRENT_INCIDENT';
